/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import React from 'react';
import ExpansionGrid from '../../Components/ExpansionGrid';

function NomineeDetailsReview(props) {
    const { reviewData } = props

    const apiKeysUsedForDisplayingNomieeLabels = {
        // "isNominee" : "Is Nominee Added",
        // ...(reviewData.kycNominee[0].isNominee ? {
            "nomineeNamePrefix": "Nominee Prefix",
            "nomineeFirstName": "Nominee Name",
            "nomineeDob": "Nominee Date Of Birth (DOB)",
            "relationWithNominee": "Nominee Relation",
            "nomineeAddress1": "Address",
            "nomineePincode": "Pincode",
            "nomineeCity": "City",
            "nomineestate": "State",
            "nomineeCountry": "Country",
            "nomineeMobile": "Mobile",
            "nomineeEmail": "Email",
            "nominationPercent": "Nomination Percentage",
            "nomineeIdentificationDetail": "Nominee Identification Detail",
            "nomineeIdentificationDetailData": "Nominee Identification Detail Data"
        // } 
        // : {})
    }

    const apiKeysUsedForDisplayingGuardianLabels = {
        "guardianNamePrefix": "Guardian Prefix",
        "guardianFirstName": "Guardian Name",
        "guardianRelation": "Guardian Relation",
        "guardianAddress1": "Guardian Address",
        "guardianPincode": "Guardian Pincode",
        "guardianCity": "Guardian City",
        "guardianState": "Guardian State",
        "guardianCountry": "Guardian Country",
        "guardianMobileNo": "Guardian Mobile",
        "guardianEmailId": "Guardian Email",
        "guardianIdentificationDetail": "Guardian Identification Detail",
        "guardianIdentificationDetailData": "Guardian Identification Detail Data"
    }

    const getNomineeReview = () => {
        let view = []
        reviewData && reviewData.kycNominee.forEach(nominee =>{
            let apiKeysOfNominee = { ...apiKeysUsedForDisplayingNomieeLabels }
            if(nominee.guardian){
                apiKeysOfNominee = { ...apiKeysOfNominee, ...apiKeysUsedForDisplayingGuardianLabels }
            }

            view.push(<Grid container item xs={12} alignItems={"center"} >
                    <Typography variant="body2" css={{fontWeight:"bold"}}>{nominee.nomineeType + " Nominee"}</Typography>
                </Grid>)

            Object.keys(apiKeysOfNominee).forEach(key=>
                view.push(<Grid container item xs={6} md={3} lg={2} alignItems={"center"} css={{ border: "1px dashed lightgrey" }}>
                    <Grid item xs={12}>
                        <Typography variant="body2" css={{ color: "#0098B0" }}>{apiKeysOfNominee[key]}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" /* color="#333333" fontWeight={"bold"} */ css={{ wordBreak: "break-word" }}>{(key.includes("guardian") ? nominee.kycStagingGuardians[0][key] : nominee[key]) || "--"}</Typography>
                    </Grid>
                </Grid>)
            )
        })
        return view;
    }

    const getAccordianData = () => {
        return <Grid container spacing={3} css={{ padding: "10px" }}>
            <Grid container item xs={12} alignItems={"center"}>
                <Grid item xs={12}>
                    <Typography variant="body2" css={{ color: "#0098B0" }}>{"Is Nominee Added"}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="body2" /* color="#333333" fontWeight={"bold"} */ css={{ wordBreak: "break-word" }}>{reviewData && reviewData.kycNominee[0] && reviewData.kycNominee[0].isNominee ? "YES" : "NO"}</Typography>
                </Grid>
            </Grid>
            {getNomineeReview()}            
        </Grid>
    }

    return (
        <ExpansionGrid title={"Nominee Details"} accordianData={getAccordianData()} />
    );
}

export default NomineeDetailsReview;